/// <amd-module name="typeahead/features/ClarifySuggestionRegionType.ts" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {ISuggestionResult} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {SuggestionRendererUtils} from "../core/presentation/SuggestionRendererUtils";

const configuration: IStripingConfiguration[] = [{
    clients: ["Homepage", "HotelsLandingPage", "Hotels.Search"],
    lobs: ["HOTELS"],
},
];

const KR_SITE_ID = "16";

export class ClarifySuggestionRegionType implements IExperimentalFeature, ISuggestionsModifier {

    public modifySuggestions(suggestions: ISuggestionResult[], context: IContext, options: any): object[] {
        const isWithinMobileBreakpoint = TypeaheadUtils.isWithinMobileBreakpoint();
        if (this.shouldClarifySuggestionType(context, suggestions, isWithinMobileBreakpoint)) {
            suggestions.forEach((sr: ISuggestionResult): void => {
                // Google Maps Blank Type
                if (sr.category === "GOOGLEMAPS") {
                    return;
                }
                // Display Search Result Types
                const compatibleTypes: string[] = [
                    "AIRPORT", "CITY", "MULTICITY", "NEIGHBORHOOD", "POI", "ADDRESS", "METROCODE",
                    "HOTEL", "MULTIREGION", "TRAINSTATION", "METROSTATION"];
                if (compatibleTypes.indexOf(sr.type) === -1) { return; }
                sr.regionNames.displayName = "<span style='display: flex;'><div class='singleLineText' "
                    + "style= 'overflow: hidden; text-overflow: ellipsis;'>" + sr.regionNames.displayName + "</div>"
                    + SuggestionRendererUtils.formatTypeDesktop(SuggestionRendererUtils.getTextType(sr))
                    + "</span>";
            });
        }
        return suggestions;
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments([].concat.apply([], configuration));
    }

    private shouldClarifySuggestionType(context: IContext, suggestions: ISuggestionResult[],
                                        isWithinMobileBreakpoint: boolean): boolean {
        return !isWithinMobileBreakpoint && context.siteid !== KR_SITE_ID
            && ExecutionHelper.shouldExecute(context, configuration) && suggestions && suggestions.length > 0;
    }
}
